import {
  type CatalogEquipmentAnswerItem_OutputType,
  type EquipmentHeatPumpResponse_OutputType,
  type EquipmentWaterHeaterResponse_OutputType,
  HeatPumpEquipmentOptionsType,
  type HeatPumpLegacyAnswerItemType,
  JobServiceEquipmentType,
  type NewHVACSystemType
} from '@shared/generated';

import { isEnumValue } from './isEnumValue';

export const isAHRIHeatPump = (
  equipment: object
): equipment is EquipmentHeatPumpResponse_OutputType => {
  if (equipment === null || equipment === undefined) {
    return false;
  }
  return (
    'ahri_id' in equipment &&
    'series_name' in equipment &&
    'duct_type' in equipment
  );
};

export const isLegacyHeatPump = (
  equipment: object
): equipment is HeatPumpLegacyAnswerItemType => {
  if (equipment === null || equipment === undefined) {
    return false;
  }
  return (
    'id' in equipment && 'manufacturer' in equipment && 'model' in equipment
  );
};

export const isEnergyStarHeatPumpWaterHeater = (
  equipment: object
): equipment is EquipmentWaterHeaterResponse_OutputType => {
  if (equipment === null || equipment === undefined) {
    return false;
  }
  return (
    'energy_star_unique_id' in equipment &&
    'energy_star_partner' in equipment &&
    'heat_pump_type' in equipment
  );
};

export const isLegacyHeatPumpWaterHeater = (
  equipment: object
): equipment is CatalogEquipmentAnswerItem_OutputType => {
  if (equipment === null || equipment === undefined) {
    return false;
  }
  return (
    'contractor_equipment' in equipment &&
    'new_equipment_manufacturer' in equipment &&
    'new_equipment_model' in equipment
  );
};

export const isNewHVACSystemEquipmentType = (
  value: unknown
): value is NonNullable<NewHVACSystemType['equipment_type']> => {
  return (
    isEnumValue(JobServiceEquipmentType, value) ||
    isEnumValue(HeatPumpEquipmentOptionsType, value)
  );
};
